import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';
import BaseUrl from '../../../assets/utils/accessToken'
const initialState = {
  exitPointsConfig: [],
  exitPointsConfigStatus: 'idle',
  exitPointStatus: 'idle',
  error: null,
  exitPoint: null,
  id: null
}

export const fetchExitPointsConfig = createAsyncThunk('exitPoint/fetchExitPointsConfig', async (param, { rejectWithValue }) => {
  const token=localStorage.getItem('token')
  try {
  const response = await axios.get(BaseUrl+'/exitPointsConfig/',
    {
      headers: {
        'Authorization': `Token ${token}`
      }
    }

  )
   console.log(response.data,'response.data')

   return response.data

  } catch (err) {
  let error = err;
  if (!error.response) {
    throw err;
  }
  console.log("error.response from inside the CAT", error.response);
  return rejectWithValue(error.response);
  }
  })
  

export const fetchExitPointById = createAsyncThunk('exitPoint/fetchExitPointById', 
async (id, { rejectWithValue }) => {
  const token=localStorage.getItem('token')
  try {
  const response = await axios.get(BaseUrl+`/exitPointsConfig/${id}/`, {
    headers: {
      'Authorization': `token ${token}`
    }
  })
  // console.log(response.data,'response.data')

  return response.data

} catch (err) {
let error = err;
if (!error.response) {
  throw err;
}
console.log("error.response from inside the CAT", error.response);
return rejectWithValue(error.response);
}
})
export const addNewExitPoint = createAsyncThunk(
  'exitPoint/addNewExitPoint',
  async (initialExitPoint, { rejectWithValue }) => {
   const token=localStorage.getItem('token')
   try {
    const response = await axios.post(BaseUrl+`/exitPointsConfig/create/`, initialExitPoint, {
      headers: {
        'Authorization': `token ${token}`
      }
    })
    return response.data

  } catch (err) {
  let error = err;
  if (!error.response) {
    throw err;
  }
  console.log("error.response from inside the CAT", error.response);
  return rejectWithValue(error.response);
  }
  })
  

export const updateExitPoint = createAsyncThunk(
  'exitPoint/updateExitPoint',
  async (data, { rejectWithValue }) => {
    const token=localStorage.getItem('token')

    try {
      const response = await axios.put(BaseUrl+`/exitPointsConfig/${data.id}/edit/`, data.modified, {
        headers: {
          'Authorization': `token ${token}`
        }
      })
      console.log(data, 'updatedExitPoint')
      console.log(response.data, 'response.data')
      return response.data

    } catch (err) {
    let error = err;
    if (!error.response) {
      throw err;
    }
    console.log("error.response from inside the CAT", error.response);
    return rejectWithValue(error.response);
    }
    })

export const deleteExitPoint = createAsyncThunk('exitPoint/deleteExitPoint', async (id, { rejectWithValue }) => {
  const token=localStorage.getItem('token')
  try {
  const response = await axios.delete(BaseUrl+`/exitPointsConfig/${id}/delete/`, {
    headers: {
      'Authorization': `token ${token}`
    }
  })
  // console.log(response.data,'response.data')

  return response.data

} catch (err) {
let error = err;
if (!error.response) {
  throw err;
}
console.log("error.response from inside the CAT", error.response);
return rejectWithValue(error.response);
}
})
const exitPointsConfigSlice = createSlice({
  name: ' exitPoint',
  initialState,
  extraReducers: {

    [fetchExitPointsConfig.pending]: (state, action) => {
      state.exitPointsConfigStatus = 'loading'
    },
    [fetchExitPointsConfig.fulfilled]: (state, action) => {
      state.exitPointsConfigStatus = 'succeeded'
      // Add any fetched posts to the array
      state.exitPointsConfig = action.payload
    },
    [fetchExitPointsConfig.rejected]: (state, action) => {
      state.exitPointsConfigStatus = 'failed'
      if (action.payload) {
        state.error = action.payload
      } else {
        state.error = action.error
      }
    },

    [fetchExitPointById.pending]: (state, action) => {
      state.exitPointsConfigtatus = 'loading'
    },
    [fetchExitPointById.fulfilled]: (state, action) => {
      state.exitPointsConfigtatus = 'succeeded'

      // Add any fetched posts to the array
      state.exitPoint = action.payload
    },
    [fetchExitPointById.rejected]: (state, action) => {
      state.exitPointsConfigtatus = 'failed'
      if (action.payload) {
        state.error = action.payload
      } else {
        state.error = action.error
      }
    },
    [addNewExitPoint.fulfilled]: (state, action) => {
      state.exitPointsConfig.push(action.payload)
    },
    [deleteExitPoint.fulfilled]: (state, action) => {
      // state.exitPointsConfig.push(action.payload)
    },
    [updateExitPoint.fulfilled]: (state, action) => {
      const result = state.exitPointsConfig.filter(exitPoint => exitPoint.id !== action.payload.id);
      // console.log("exitPoint id from filter from slice",exitPoint.id)
      result.push(action.payload)
      state.exitPointsConfig = result
      console.log("action.payload.id from slice",action.payload)

    },
    [addNewExitPoint.rejected]: (state, action) => {
      state.exitPointsConfigtatus = 'failed'
      if (action.payload) {
        state.error = action.payload
      } else {
        state.error = action.error
      }
    },
    [deleteExitPoint.rejected]: (state, action) => {
      state.exitPointsConfigtatus = 'failed'
      if (action.payload) {
        state.error = action.payload
      } else {
        state.error = action.error
      }
    },
    [updateExitPoint.rejected]: (state, action) => {
      state.exitPointsConfigtatus = 'failed'
      if (action.payload) {
        state.error = action.payload
      } else {
        state.error = action.error
      }
    },
  },

})


export default exitPointsConfigSlice.reducer

 export const selectAllExitPointsConfig = state => state.exitPoint.exitPointsConfig